export default __webpack_public_path__ + "static/media/splash_1.595a6717.svg";